module.exports = __webpack_public_path__ + "media/images/games/35gender/jewelry-dd8205a00c8867de10d05bf709907169.png";